import { render } from "./VisualizarAssinatura.vue?vue&type=template&id=52f5f68b&scoped=true"
import script from "./VisualizarAssinatura.vue?vue&type=script&lang=js"
export * from "./VisualizarAssinatura.vue?vue&type=script&lang=js"

import "./VisualizarAssinatura.vue?vue&type=style&index=0&id=52f5f68b&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52f5f68b"]])

export default __exports__